import { get } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Fetches the agent's last call data from the cache.
 *
 * @param {string} agentId - The agent's ID.
 * @param {string} apiKey - The tenant API key.
 * @returns {Promise<Object|null>} The agent's last call data (contactId, campaignId, segmentId, skillId, lastDialedNumber) or null if unavailable.
 */
export async function getAgentLastCall(agentId, apiKey) {
	try {
		const session = await fetchAuthSession();
		const idToken = session.tokens.idToken;

		const agentResponse = await get({
			apiName: 'cdyxoutreach',
			path: `/cache/agent/${agentId}`,
			options: {
				headers: {
					Authorization: `Bearer ${idToken}`,
					'x-api-key': apiKey,
				},
			},
		}).response;

		const data = await agentResponse.body.json();
		return data || null;
	} catch (e) {
		console.warn('Agent last call cache not available', e);
		return null;
	}
}
